export default "__VITE_ASSET__CziDcTWC__"